<template>
    <div class="ah-page outsourcing-info-setting">
        <div class="page-header bottom-margin">
            <div class="ah-container ">
                <div class="title-row">
                    <div class="title">
                        <h1>委外類型設定</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <div class="ah-container ">
            <div class="ah-panel">
                <div class="panel-body">
                    <group-item-editor
                        v-model="list"
                        :enableAddGroup="false"
                        @itemAdd="onGroupItemsAdd"
                        @itemEdit="onGroupItemsEdit"
                        @itemDelete="onGroupItemsDelete"
                        @sortUpdate="onGroupItemsSortUpdate"
                    ></group-item-editor>
                </div>
            </div>
        </div>
        <EditDialog v-if="showEditDialog" ref="editDialog" :visible="showEditDialog" :inputObject="selectedItem" @close="updateList" @delete="deleteItem" />
    </div>
</template>
<script>
import groupItemEditor from '@/components/ui/GroupItemEditor';
import EditDialog from './EditDialog';

export default {
    components: {
        EditDialog,
        groupItemEditor,
    },
    data() {
        return {
            list: [
                {
                    sno: 1,
                    name: '委外廠商類型',
                    children: [],
                },
                {
                    sno: 2,
                    name: '委外勞務類型',
                    children: [],
                },
            ],
            showEditDialog: false,
            collapse1: 'department',
            collapse2: 'vendor',
            collapse3: 'outsourcing',
            selectedItemType: '',
            selectedItem: null,
            draggedItem: {},
            departmentList: [],
            vendorList: [],
            outsourcingList: [],
        };
    },
    created() {
        this.updateData();
    },
    methods: {
        updateData() {
            this.$api({
                url: '/VendorSettingPage/GetVendorSettings',
                method: 'GET',
            }).then((resp) => {
                this.list = this.groupItemsDataAdopter(resp.data);
            });
        },
        groupItemsDataAdopter(orignData) {
            const data = [
                {
                    sno: 1,
                    name: '委外廠商類型',
                    children: [],
                    editable: false,
                    draggable: false,
                    addChild: true,
                },
                {
                    sno: 2,
                    name: '委外勞務類型',
                    children: [],
                    editable: false,
                    draggable: false,
                    addChild: true,
                },
            ];

            const vendorItems = [];
            orignData.vendorSettings_VD.forEach((item) => {
                vendorItems.push({
                    sno: item.sno,
                    name: item.catnam,
                    sot: item.sot,
                    editable: true,
                    draggable: true,
                });
            });
            data[0].children = vendorItems;

            const outsourcingItems = [];
            orignData.vendorSettings_OS.forEach((item) => {
                outsourcingItems.push({
                    sno: item.sno,
                    name: item.catnam,
                    sot: item.sot,
                    editable: true,
                    draggable: true,
                });
            });
            data[1].children = outsourcingItems;

            return data;
        },
        onGroupItemsSortUpdate(items) {
            this.$api({
                url: '/VendorSettingPage/UpdateSort',
                method: 'POST',
                data: { items },
            }).finally(() => {
                this.updateData();
            });
        },
        onGroupItemsEdit(item) {
            this.$api({
                url: '/VendorSettingPage/UpdateName',
                method: 'POST',
                data: { sno: item.sno, catnam: item.name },
            }).finally(() => {
                this.updateData();
            });
        },
        onGroupItemsAdd(item) {
            this.$api({
                url: '/VendorSettingPage/Add',
                method: 'POST',
                data: {
                    catnam: item.name,
                    type: item.parent,
                },
            }).finally(() => {
                this.updateData();
            });
        },
        onGroupItemsDelete(item) {
            this.$api({
                url: '/VendorSettingPage/Delete',
                method: 'POST',
                data: { sno: item.sno },
            }).finally(() => {
                this.updateData();
            });
        },
    },
};
</script>
<style lang="scss" scoped="">
@import "@/assets/scss/vars.scss";
</style>
